export const colors = {
    primary: {
        default: '#0068ea',
        dark: '#0654b6',
        light: '#f5f7fe',
    },
    error: {
        default: '#e03030',
        dark: '#b92525',
        light: '#f5f0f0',
    },
    warning: {
        default: '#e6a700',
        dark: '#b8860b',
        light: '#fff8e1',
    },
    gray: {
        '01': '#313131',
        '02': '#757575',
        '03': '#8f8f8f',
        '04': '#bbbbbb',
        '05': '#dddddd',
        bg: '#f7f7f7',
    },
    black: '#000000',
    white: '#ffffff',
};
export function getColor(name, variant = 'default') {
    const color = colors[name];
    if (typeof color === 'string') {
        return color;
    }
    if (color && typeof color === 'object' && variant in color) {
        return color[variant];
    }
    throw new Error(`Color \`${name}\` with variant \`${variant}\` not found in colors.`);
}
//# sourceMappingURL=colors.js.map